import { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';

import { RegisterForm } from '@components/App/Auth/RegisterForm';

const AppRegister: NextPage = () => {
  return (
    <>
      <Head>
        <title>Registrierung</title>
      </Head>
      <RegisterForm />
    </>
  );
};

export default AppRegister;
